import React from 'react';
import { FaMicrophone, FaUpload, FaTimes, FaPlay, FaPause } from 'react-icons/fa';

const AudioForm = ({ content, setContent, mediaFile, mediaPreview, handleMediaChange, clearMedia }) => {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const audioRef = React.useRef(null);

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) { audioRef.current.pause(); }
    else { audioRef.current.play(); }
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      <div>
        <label className="text-sm text-gray-600 mb-2 block">Caption (Optional)</label>
        <textarea
          data-testid="audio-caption-input"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          className="w-full bg-gray-100 border border-gray-300 focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2] rounded-lg p-4 text-gray-900 placeholder:text-gray-400 transition-all outline-none min-h-[80px] resize-none"
          placeholder="Say something about this audio..."
        />
      </div>

      <div>
        <label className="text-sm text-gray-600 mb-2 block">Audio File</label>
        {mediaPreview ? (
          <div className="bg-gradient-to-r from-[#4A90E2]/5 to-[#A855F7]/5 border border-[#4A90E2]/20 rounded-xl p-4" data-testid="audio-preview">
            <div className="flex items-center space-x-3">
              <button
                type="button"
                onClick={togglePlay}
                className="w-12 h-12 bg-gradient-to-r from-[#4A90E2] to-[#A855F7] rounded-full flex items-center justify-center text-white hover:opacity-90 transition-opacity flex-shrink-0"
                data-testid="audio-preview-play"
              >
                {isPlaying ? <FaPause size={14} /> : <FaPlay size={14} className="ml-0.5" />}
              </button>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-800 truncate">{mediaFile?.name || 'Audio file'}</p>
                <div className="w-full h-1.5 bg-gray-200 rounded-full mt-1.5">
                  <div className="h-full bg-gradient-to-r from-[#4A90E2] to-[#A855F7] rounded-full w-0 transition-all" />
                </div>
              </div>
              <button
                type="button"
                onClick={() => { clearMedia(); setIsPlaying(false); }}
                className="text-gray-400 hover:text-red-500 p-2"
              >
                <FaTimes size={14} />
              </button>
            </div>
            <audio ref={audioRef} src={mediaPreview} onEnded={() => setIsPlaying(false)} className="hidden" />
          </div>
        ) : (
          <label className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl p-8 cursor-pointer hover:border-[#4A90E2]/50 transition-colors" data-testid="audio-upload-area">
            <div className="w-14 h-14 bg-[#4A90E2]/10 rounded-full flex items-center justify-center mb-3">
              <FaMicrophone className="text-2xl text-[#4A90E2]" />
            </div>
            <p className="text-gray-600 text-sm font-medium">Upload an audio file</p>
            <p className="text-gray-400 text-xs mt-1">MP3, WAV, OGG, M4A</p>
            <input
              type="file"
              accept="audio/*"
              onChange={handleMediaChange}
              className="hidden"
              data-testid="audio-file-input"
            />
          </label>
        )}
      </div>
    </>
  );
};

export default AudioForm;
